const resolveUnitParty = (...candidates) => {
  for (const candidate of candidates) {
    if (!candidate) continue;

    if (typeof candidate === 'string' || typeof candidate === 'number') {
      const name = String(candidate).trim();
      if (name) return { name, phone: '' };
      continue;
    }

    const name = String(candidate.name || candidate.nickname || candidate.fullName || '').trim();
    const phone = String(candidate.phoneNumber || candidate.phone || '').trim();
    if (name || phone) return { name, phone };
  }

  return null;
};

export const getUnitPartnerDisplay = (unit) => resolveUnitParty(
  unit?.rpOwner,
  unit?.partner,
  unit?.kudOwner,
  unit?.rpOwnerName,
  unit?.partnerName,
  unit?.kudOwnerName
);

export const getUnitRegionalPartnerDisplay = (unit) => resolveUnitParty(
  unit?.puskud,
  unit?.regionalPartner,
  unit?.puskudOwner,
  unit?.puskudName,
  unit?.regionalPartnerName,
  unit?.puskudOwnerName
);

export const getUnitStewardDisplay = (unit) => resolveUnitParty(
  unit?.steward,
  unit?.stewardName
);
